module.exports = __webpack_public_path__ + "static/media/aida.1eb57ca2.png";